export default __webpack_public_path__ + "static/media/raggera.3cc63957.png";